import './App.css';
import Navigation from './Component/Navigation';
import Footer from './Component/Footer';
import Home from './Home';
import Menu from './Menu';
import About from './About';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './i18n';

//https://coolors.co/0b3142-ffffff-dc143c-748cab

function App() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <div
      className={`${isArabic ? 'arabic-font text-right' : 'falafel-font text-left'}`}
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      {/* ✅ Navigation forced to LTR */}
      <div dir="ltr">
        <Navigation />
      </div>

      {/* Main content follows language direction */}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/Menu" element={<Menu />} />
           <Route path="/About/" element={<About />} />
        </Routes>
      </main>

<div><Footer /></div>
      
    </div>
  );
}

export default App;
